import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-termsofservice",
  templateUrl: "./termsofservice.component.html",
  styleUrls: ["./termsofservice.component.scss"],
})
export class TermsofserviceComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /agir/src/app/components/termsofservice/termsofservice.component.ts